import { render, staticRenderFns } from "./ClientAgreementsWaiting.vue?vue&type=template&id=4ed5ce24&scoped=true&"
import script from "./ClientAgreementsWaiting.vue?vue&type=script&lang=js&"
export * from "./ClientAgreementsWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5ce24",
  null
  
)

export default component.exports